import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12 2.4a.9.9 0 0 1 .9.9v15.108l2.34-2.52a.9.9 0 0 1 1.32 1.224l-3.9 4.2a.9.9 0 0 1-1.32 0l-3.9-4.2a.9.9 0 1 1 1.32-1.224l2.34 2.52V3.3a.9.9 0 0 1 .9-.9",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }